import { Button } from "@mui/material";
import { Severity } from "constants/Severity";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { useSnackbar, SnackbarKey } from "notistack";

type Props = {
  isOpen: boolean;
  message: string;
  autoHideDuration: number;
  severity: Severity;
  onClose: () => void;
};

const AlertSnackbar = ({
  isOpen,
  message,
  autoHideDuration,
  severity,
  onClose,
}: Props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const close = (snackbarId: SnackbarKey) => (
    <>
      <Button
        onClick={() => {
          closeSnackbar(snackbarId);
          onClose;
        }}>
        <CloseIcon style={{ color: "white" }} />
      </Button>
    </>
  );

  useEffect(() => {
    if (message != "" && isOpen) {
      enqueueSnackbar(message, {
        action: snackbarId => close(snackbarId),
        autoHideDuration: autoHideDuration,
        variant: severity,
        preventDuplicate: false,
      });
    }
  }, [enqueueSnackbar, isOpen, message]);
  return null;
};

export default AlertSnackbar;
